import { Breadcrumb, List } from "antd";
import React from "react";

type ComponentWithAncestors = {
  name: string;
  ancestors: { name: string; guiIndex: number }[];
  guiIndex: number | null;
};

type ComponentsWithAncestorProps = {
  components: ComponentWithAncestors[];
  heading?: string;
};

const lexicographicalArrayCompare = (a, b) => {
  if (a.length === 0 || b.length === 0) {
    return a.length - b.length;
  }
  return a[0] - b[0] || lexicographicalArrayCompare(a.slice(1), b.slice(1));
};

const sortSpacesByGuiIndex = (
  spaces: ComponentWithAncestors[],
): ComponentWithAncestors[] =>
  [...spaces].sort((a, b) =>
    lexicographicalArrayCompare(
      [...a.ancestors.map((an) => an.guiIndex), a.guiIndex],
      [...b.ancestors.map((an) => an.guiIndex), b.guiIndex],
    ),
  );

export const ComponentsWithAncestors = (props: ComponentsWithAncestorProps) => {
  const sortedComponents = sortSpacesByGuiIndex(props.components);
  return (
    <>
      {props.heading && <h3>{props.heading}</h3>}
      <List
        size="small"
        dataSource={sortedComponents}
        renderItem={(item) => (
          <List.Item>
            <Breadcrumb>
              {item.ancestors?.map((ancestor) => (
                <Breadcrumb.Item key={ancestor.name}>
                  {ancestor.name}
                </Breadcrumb.Item>
              ))}
              <Breadcrumb.Item>{item.name}</Breadcrumb.Item>
            </Breadcrumb>
          </List.Item>
        )}
      />
    </>
  );
};
